<template>
  <div class="contArea tpd"
       style="text-align: center; width: 100%; font-size: 1.2rem;"
  >
    <p style="font-weight: bold; padding-top: 10px;"> 상품 정보 </p>
    <p>BMW ServiceCare+ / {{solicitation['options']['pkg']['title']}}</p>
    <p>₩ {{Number(solicitation['options']['subsc']['payments']['price_payment']).toLocaleString()}} 원</p>

    <p style="font-weight: bold; padding-top:20px"> 차량정보 </p>
    <p>{{solicitation['options']['vehicle']['num_id']}}</p>
    <p>{{solicitation['options']['vehicle']['num_reg']}}</p>

    <radio-input
        ref='cardType'
        :title="'결제카드종류'"
        :title-class="'conTit1 non'"
        :tStyle="'font-weight: bold;padding-top: 37px;font-size: 1.2rem;'"
        :cStyle="'justify-content: center;'"
        :lists="cardTypes"
        :selected="selectCardType"
        :val.sync="selectCardType"
        :option-val-id="true"
        >
    </radio-input>

    <popup-alert v-if="activatedAlert" title="알림" @close="alertClose">
      <popup-msg :type="alertMsg"></popup-msg>
    </popup-alert>

    <button-apply before="/" @submit="pay"></button-apply>
  </div>
</template>

<script>
import axios from "axios";
import Const from "../../../helpers/Const";
import {api} from "../../../api";

import ButtonApply from "./ButtonSubscApply.vue";
import PopupAlert from '../../../components/Popup/PopupAlert.vue';
import PopupMsg from "../../../components/Popup/PopupMsgTemplate";

import RadioInput from '@/components/Input/RadioInput.vue';

export default {
  components: {
    ButtonApply,
    PopupAlert,
    PopupMsg,
    RadioInput,
  },

  props: {solicitation: Object},

  data() {
    return {
      activatedAlert: false,
      alertMsg: null,
      cardTypes: Const.getPaymentCardType(),
      selectCardType : Const.CARD_TYPE.DEF,
    };
  },
  watch:{
    selectCardType(value) {
      if(this.solicitation) {
        //console.log(value);
        this.solicitation.options.subsc.payments.card_type = value;
      }
    }
  },
  methods: {
    alertClose() {
      this.activatedAlert = false;
    },

    pay() {

      if(!this.solicitation.options.subsc.payments.card_type) {
        this.solicitation.options.subsc.payments.card_type = this.selectCardType;
      }

      if(this.solicitation.options.path) {
        this.solicitation.options.subscRecommendedAdvisor = {
          user_id: this.solicitation.options.path.user_id,
        }
      }

      axios.post(
          api.subscs, this.solicitation.options
      ).then((res) => {
        this.$store.commit('setBtnLoading', true);
        const url = res.data.data.redirect;
        if(url) window.location.href = url;
      }).catch(({response}) => {
        this.warnCheck = false;
        const msg = response.data.data.msg;
        const statusCode = response.data.data.status_code;
        if (typeof msg != 'undefined') {
          //PM_SUBSC_EXISTS = 5011; //구독있음 ERROR CODE

          if (Const.getErrorCodes().includes(statusCode)) {
            this.alertMsg = msg;
            this.activatedAlert = true;
            return;
          }
        }

        this.alertMsg  = `[${response.status}] ${response.statusText}`;
        this.activatedAlert= true;
      });
    },
  },
}
</script>
